import { styled } from '@zoopla-eng/zds-components/themes';

export const RegTabsContainer = styled('div', {
    '[role="tablist"]': {
        '@L100': {
            width: '50%'
        }
    }
});
